import { IconButton, Tooltip } from '@material-ui/core';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import { useDispatch } from 'react-redux';
import { openModalImagenesAction } from '../../../ducks/proveedorTerrestreDuck';

const BImagenes = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openModalImagenesAction({
            paquete
        }))
    } 
    
    return (
        <Tooltip title="Imagenes">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <PhotoLibraryIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BImagenes;